import React, { useState, useCallback } from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import { SUPPORT_CONTACTS } from '../constants/supportContacts';
import { ContactSection } from './ContactSection';
import { HorarioCardComponent } from './HorarioCard';
import logger from '../../../utils/logger';

export const SupportCardContent = () => {
  const [copiedNumber, setCopiedNumber] = useState(null);

  const handleCopyNumber = useCallback(async (number, rawNumber) => {
    try {
      await navigator.clipboard.writeText(rawNumber);
      setCopiedNumber(number);
      setTimeout(() => setCopiedNumber(null), 2000);
    } catch (err) {
      logger.error('Erro ao copiar:', err);
    }
  }, []);

  const getWhatsAppLink = useCallback((number) => {
    const cleanNumber = number.replace(/\D/g, '');
    return `https://wa.me/55${cleanNumber}`;
  }, []);

  const { telefones, whatsapp, horarioAtendimento } = SUPPORT_CONTACTS;

  return (
    <div>
      <ContactSection
        icon={FaPhoneAlt}
        title="Telefones para Ligar"
        color="#4A90E2"
        items={telefones}
        type="telefone"
        copiedNumber={copiedNumber}
        onCopyNumber={handleCopyNumber}
        onGetWhatsAppLink={getWhatsAppLink}
      />

      <ContactSection
        icon={FaWhatsapp}
        title="WhatsApp"
        color="#25D366"
        items={whatsapp}
        type="whatsapp"
        copiedNumber={copiedNumber}
        onCopyNumber={handleCopyNumber}
        onGetWhatsAppLink={getWhatsAppLink}
      />

      <HorarioCardComponent horarioAtendimento={horarioAtendimento} />
    </div>
  );
};